import * as React from "react";
const SvgFiRrTrashCanSlash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-trash-can-slash_svg__a)">
      <path
        fill="#062147"
        d="m23.707 22.293-3.803-3.803V6h1a1 1 0 1 0 0-2h-3.1a5.01 5.01 0 0 0-4.9-4h-2a5.01 5.01 0 0 0-4.899 4h-.504a1 1 0 0 0-.082.004L1.707.294A.999.999 0 1 0 .293 1.706l22 22a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414m-5.803-5.803L7.414 6h10.49zm-7-14.49h2c1.304 0 2.415.836 2.828 2H8.076a3.005 3.005 0 0 1 2.828-2m6.947 19.882a1 1 0 0 1-.326 1.376 5 5 0 0 1-2.62.742H9c-2.757 0-5-2.243-5-5v-8.5a1 1 0 1 1 2 0V19c0 1.654 1.346 3 3 3h5.904a3 3 0 0 0 1.571-.443 1 1 0 0 1 1.376.325"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-trash-can-slash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTrashCanSlash;
